// src/pages/account/ProfilePage.jsx
import ProfilePanel from "./ProfilePanel";
export default function ProfilePage() {
  return <ProfilePanel />;
}